module.exports = __webpack_public_path__ + "img/checkbox.019a27ca.png";